// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"bp-z","imageAndVideoCount":"cp-z","imageAndVideoContainer":"dp-z","viewAllReviews":"ep-z"};